import { useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";

function VerificaToken() {
  let history = useHistory();

  const getUser = () => {
    if (localStorage.getItem("accessToken")) {
      axios
        .get(
          "https://website-8bit-motors.herokuapp.com/account/autenticazione",
          {
            headers: {
              accessToken: localStorage.getItem("accessToken"),
            },
          }
        )
        .then((response) => {
          if (response.data.error) {
            history.push("/ModificaNonAutorizzata");
          }
        }).catch(() => {
          alert("Connessione Non Disponibile");
        });;
      const userSession = JSON.parse(localStorage.getItem("user"));
      return userSession;
    }
  };

  const [user, setUser] = useState(getUser());

  const saveUser = (userSession) => {
    localStorage.setItem("user", JSON.stringify(userSession));
    setUser(userSession);
  };

  return {
    setUser: saveUser,
    user,
  };
}

export default VerificaToken;
